<!-- eslint-disable -->
<template>
<div v-if="loading == true">
    <div class="loading">
        <div class="loader"></div>
    </div>
</div>
<div v-else class="mainPage" style="width:100%">
    <!-- loading-->
    <!-- <div :class="{'hide':true, 'display':displayMainContent}" class="mainContent" :style="{background:showLoading?'#fcda6c':'#8494BD'}">
        <img id="headerimg" src="http://img.jacoo.cn/upload/dream/loading1.gif" v-if="showLoading" style="width:100%;">
        <img id="headerimg" src="http://img.jacoo.cn/upload/dream/starting.gif" v-if="!showLoading" style="width:100%;z-index:1">
        <img class="btn_skip" src="http://img.jacoo.cn/upload/dream/btn_skip.png" v-if="!showLoading" @click="skip()" style="width:20%;z-index:2">
    </div> -->
    <!-- 主页 -->
    <div class="displayCardList homePage" :class="{'mask':true, 'display':displayCardList}" style="overflow-y: hidden;overflow-x: hidden;">
        <div style="position:relative;" :class="{'dreamScale':dreamScale}">
            <img src="http://img.jacoo.cn/upload/feiyi2/home_bg.png" alt="" style="width:100%;">
            <div class="btn_play" style="z-index:3;top:90%;position:absolute">
                <img src="http://img.jacoo.cn/upload/feiyi2/home_start.png" style="width:33%;" @click="dreamClick">
            </div>
            <div class="hasUser">
                <div class="hasuserBg">目前有{{ViewNum}}人在制作非遗赢好礼</div>
            </div>
            <div class="rightBtn" style="z-index:4;right:0;top:3%">
                <div class="ruleBtn">
                    <img src="http://img.jacoo.cn/upload/feiyi2/icon_rule.png" alt="" @click="displayRule = true" style="width:35%">
                </div>
                <div class="priseBtn" style="margin-top:10px;">
                    <img src="http://img.jacoo.cn/upload/feiyi2/icon_prize.png" alt="" @click="myPrise('home')" style="width:35%">
                </div>
                <div class="priseBtn" style="margin-top:10px;">
                    <img src="http://img.jacoo.cn/upload/feiyi2/icon_view.png" alt="" @click="toVedio" style="width:35%">
                </div>
            </div>
        </div>
    </div>
    <!-- 选择页面 -->
    <div class="displayCardList" :class="{'mask':true, 'display':displayMakeCard}" style="overflow-y: hidden;overflow-x: hidden;">
        <div style="position:relative;">
            <img src="http://img.jacoo.cn/upload/feiyi2/choose_bg.png" alt="" style="width:100%;">
            <div class="rightBtn" style="z-index:4;right:0;top:9%">
                <div class="ruleBtn">
                    <img src="http://img.jacoo.cn/upload/feiyi2/icon_prize.png" alt="" @click="myPrise('MakeCard')" style="width:32%">
                </div>
                <div class="priseBtn" style="margin-top:10px">
                    <img src="http://img.jacoo.cn/upload/feiyi2/icon_rule.png" alt="" @click="displayRule = true" style="width:32%">
                </div>
            </div>
            <!-- <div class="hasUser">
                <div class="hasuserBg">目前已产生{{ViewNum}}位书法名家,你也来试试吧！</div>
            </div> -->
            <div class="swiperContent">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div v-for="(item, i) in cardList" :key="i" class="swiper-slide">
                            <div class="swiper-slide-item" style="position:relative;">
                                <!-- <div class="chooseTitle">
                                    <img :src="item.chooseTitle" alt="" style="width:75%">
                                </div>
                                <div class="chooseTitle" style="top:-11%">
                                    <img src="https://img.jacoo.cn/upload/artist/choose_tip.png" alt="" style="width:75%">
                                </div> -->
                                <img :src="item.chooseImg" alt="家">
                                <!-- <div class="cardItemMask"></div> -->
                            </div>
                            <!-- <div class="cardItemMask"></div> -->
                        </div>
                    </div>
                    <div class="swiper-pagination" slot="pagination">

                    </div>
                    <div class="swiper-button-next">
                        <img src="http://img.jacoo.cn/upload/feiyi2/choose_arraw_right.png" alt="" @click="next" style="width:35%">
                    </div>
                    <div class="swiper-button-prev">
                        <img src="http://img.jacoo.cn/upload/feiyi2/choose_arraw_left.png" alt="" @click="prev" style="width:35%">
                    </div>
                </div>
            </div>
            <div class="btn_play" style="top:91%;z-index:3">
                <img src="http://img.jacoo.cn/upload/feiyi2/choose_confirm.png" style="width:30%;" @click="confirmSelect">
            </div>

        </div>
    </div>
    <!-- 介绍页 -->
    <div class="displayCardList" :class="{'mask':true, 'display':displayIntro}" style="overflow-y: hidden;overflow-x: hidden;">
        <div style="position:relative;" :class="{'dreamScale':dreamScale}">
            <img src="http://img.jacoo.cn/upload/feiyi2/choose_bg.png" alt="" style="width:100%;">
            <div class="btn_play" style="top:6%;">
                <img :src="cardList[selectCardId].infoImg1" alt="" v-if="infoNum == 1" style="width:100%;">
                <img :src="cardList[selectCardId].infoImg2" alt="" v-if="infoNum == 2" style="width:100%;">
            </div>
            <div class="cursor dreamDown" v-if="selectCardId == 0 && infoNum == 1" @click="viewMp41" style="position: absolute;top:32%;left:40%;z-index:3">
                <img src="http://img.jacoo.cn/upload/feiyi2/cursor.png" alt="" style="width:30%;">
            </div>
            <div class="cursor dreamDown" v-if="selectCardId == 0 && infoNum == 2" @click="viewMp42" style="position: absolute;top:49%;left:20%;z-index:3">
                <img src="http://img.jacoo.cn/upload/feiyi2/cursor.png" alt="" style="width:30%;">
            </div>
            <div class="cursor dreamDown" v-if="selectCardId == 1 && infoNum == 1" @click="viewMp41" style="position: absolute;top:39%;left:40%;z-index:3">
                <img src="http://img.jacoo.cn/upload/feiyi2/cursor.png" alt="" style="width:30%;">
            </div>
            <div class="cursor dreamDown" v-if="selectCardId == 1 && infoNum == 2" @click="viewMp42" style="position: absolute;top:34%;left:61%;z-index:3">
                <img src="http://img.jacoo.cn/upload/feiyi2/cursor.png" alt="" style="width:30%;">
            </div>
            <div class="cursor dreamDown" v-if="selectCardId == 2 && infoNum == 1" @click="viewMp41" style="position: absolute;top:35%;left:32%;z-index:3">
                <img src="http://img.jacoo.cn/upload/feiyi2/cursor.png" alt="" style="width:30%;">
            </div>
            <div class="cursor dreamDown" v-if="selectCardId == 2 && infoNum == 2" @click="viewMp42" style="position: absolute;top:36%;left:37%;z-index:3">
                <img src="http://img.jacoo.cn/upload/feiyi2/cursor.png" alt="" style="width:30%;">
            </div>
            <div class="rightBtn" style="z-index:4;right:0;top:9%">
                <div class="ruleBtn">
                    <img src="http://img.jacoo.cn/upload/feiyi2/icon_prize.png" alt="" @click="myPrise('intro')" style="width:32%">
                </div>
                <div class="priseBtn" style="margin-top:10px">
                    <img src="http://img.jacoo.cn/upload/feiyi2/icon_rule.png" alt="" @click="displayRule = true" style="width:32%">
                </div>
            </div>
        </div>
    </div>
    <!-- 结果页 -->
    <div class="displayCardList" :class="{'mask':true, 'display':displayHelpCard}" style="overflow-y: hidden;overflow-x: hidden;">
        <div style="position:relative;" ref="displayHelpCard">
            <img src="http://img.jacoo.cn/upload/feiyi2/choose_bg.png" alt="" style="width:100%;">
            <div class="btn_play" style="top:18%;">
                <img :src="resultImg" style="width:100%;" />
            </div>
            <!-- <div class="qrcodeImg" style="position:absolute;top:5%">
            </div> -->
            <div class="rightBtn" style="z-index:4;right:0;top:9%">
                <div class="ruleBtn">
                    <img src="http://img.jacoo.cn/upload/feiyi2/icon_prize.png" alt="" @click="myPrise('helpCard')" style="width:32%">
                </div>
                <div class="priseBtn" style="margin-top:10px">
                    <img src="http://img.jacoo.cn/upload/feiyi2/icon_rule.png" alt="" @click="displayRule = true" style="width:32%">
                </div>
            </div>
            <div class="btn_play" style="top:88%;z-index:100">
                <div class="" style="z-index:100">
                    <div style="text-align:center">
                        <img src="http://img.jacoo.cn/upload/feiyi2/result_btn_prize.png" alt="" style="width:35%;margin:0 5px;z-index:100" @click="smLottery">
                        <div style="clear:both"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 描字完成页面 -->
    <div class="displayCardList" :class="{'mask':true, 'display':displaySuccess}" style="overflow-y: scroll;overflow-x: hidden;">
        <div style="position:relative;">
            <img src="http://img.jacoo.cn/upload/family/main_bg.jpg" alt="" style="width:100%;">
            <div class="main_title">
                <img id="main_title" src="http://img.jacoo.cn/upload/family/main_title.png" style="width:95%;">
            </div>
            <div class="logoImg">
                <img src="http://img.jacoo.cn/upload/family/logo.png" style="width:45%;">
            </div>
            <div class="main_mechine">
                <img class="" id="headerimg" src="http://img.jacoo.cn/upload/family/result_sub_title.png" style="width:90%;">
            </div>
            <div class="rightBtn" style="z-index:4;right:0px;top:5%">
                <div class="ruleBtn">
                    <img src="https://img.jacoo.cn/upload/luckycard/icon_prize.png" alt="" @click="displayRule = true" style="width:50%">
                </div>
                <div class="priseBtn" style="margin-top:10px">
                    <img src="https://img.jacoo.cn/upload/luckycard/icon_rule.png" alt="" @click="myPrise()" style="width:50%">
                </div>
            </div>
            <div class="hasUser">
                <div class="hasuserBg">目前已产生{{ViewNum}}位书法名家,你也来试试吧！</div>
            </div>
            <div class="centerBagandCheats centerReasultBg" style="top:35%">
                <img src="http://img.jacoo.cn/upload/family/result_word_bg.png" alt="" style="width:90%">
            </div>
            <div class="ReasultImg">
                <img :src="successBagImg" alt="" style="width:37%;">
            </div>
            <div class="btn_play" style="top:78%;z-index:3">
                <div class="" style="z-index:100">
                    <div style="text-align:center">
                        <img src="http://img.jacoo.cn/upload/family/btn_sm_save.png" alt="" style="width:40%;margin:0 5px;z-index:100" @click="smSave">
                        <img src="http://img.jacoo.cn/upload/family/btn_sm_play.png" alt="" v-if="!closeAward" style="width:40%;margin:0 5px;z-index:100" @click="smLottery">
                        <img src="http://img.jacoo.cn/upload/family/btn_ssm_play_again.png" alt="" v-if="closeAward" style="width:40%;margin:0 5px;z-index:100" @click="playAgain">
                        <div style="clear:both"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 企业微信弹窗 -->
    <div class="makeCard1 mask1" :class="{'mask':true, 'display':displayWechatCode}">
        <div class="content-large getPrise" style="width:72%;padding:0 14%">
            <div class="rule-content " :style="{'height': awardHeight + 'px'}">
                <div class="close closeTop" style="top:-13%" @click="displayWechatCode = false">
                </div>
                <img :src="GroupQRCodeUrl" style="width:100%" alt="">
                <!-- <div style="margin-top:20px">
                    <img src="../../../../static/static24/subscribe_tip.png" style="width:100%" alt="">
                </div> -->
            </div>
        </div>
    </div>
    <!-- 结果弹窗 -->
    <div class="makeCard1" :class="{'mask':true, 'display':displayResult}">
        <div class="content-large getPrise" style="width:100%;padding:0">
            <div class="rule-content" style="padding:0">
                <video id="media" class="m-video" style="width:100%" controls preload="auto" webkit-playsinline playsinline x-webkit-airplay="allow" muted="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-orientation="portrait">
                    <source :src="videoUrl" type="video/mp4" />
                </video>
                <div class="btn_play" @click="skip" style="top:-25%;right:10%;color:#fff;width:auto;padding: 5px 20px;
    border: 1px solid #d9c9b4;
    border-radius: 15px;">
                    跳过
                </div>
            </div>
        </div>
    </div>
    <!-- 领奖弹窗 -->
    <div class="makeCard1" :class="{'mask':true, 'display':displayAwards}">
        <div class="content-large getPrise" style="width:100%;padding:0">
            <div class="rule-content awardsBg" style="padding:0">
                <img :src="Awardsimg" style="width:80%" alt="">
                <!-- <div class="close closeTop" style="top:-7%" @click="closeDisplayAwards">
                </div> -->
                <!-- <div class="AwardsName">
                    {{AwardsName}}
                </div> -->
                <!-- <div class="Awardsimg" style="top:50%">
                    <img :src="Awardsimg" alt="" style="width:65%">
                </div> -->
                <div class="bottomBtnImg" style="top:81%;width:100%">
                    <img src="http://img.jacoo.cn/upload/feiyi2/win_btn_recv.png" alt="" style="width:35%;z-index:100" @click="myPrise('home')">
                </div>
            </div>
        </div>
    </div>
    <!-- 未中奖弹窗 -->
    <div class="makeCard1" :class="{'mask':true, 'display':displayAwardsFail}">
        <div class="content-large getPrise" style="width:100%;padding:0">
            <div class="rule-content awardsFailBg" style="padding:0">
                <img src="http://img.jacoo.cn/upload/feiyi2/fail_bg.png" style="width:75%" alt="">
                <!-- <div class="close closeTop" style="top:-15%" @click="closeDisplayAwards">
                </div> -->
                <div class="bottomBtnImg" style="top:75%;width:100%">
                    <img src="http://img.jacoo.cn/upload/feiyi2/play_again.png" alt="" style="width:30%;z-index:100" @click="playAgain">
                </div>
            </div>
        </div>
    </div>
    <!-- 活动详情 -->
    <div :class="{'mask':true, 'display':displayRule}" style="overflow-y: scroll;overflow-x: hidden;background:#e6e1d7">
        <div class="" :style="{'height': '100%'}" style="position:relative;">
            <div class="returnImg" style="position:fixed">
                <img src="http://img.jacoo.cn/upload/feiyi2/prize_back.png" style="width:35%" @click="displayRule = false" alt="">
            </div>
            <img src="http://img.jacoo.cn/upload/feiyi2/rule_bg.png" style="width:100%" alt="">

            <!-- <div v-html="Rule" style="overflow: scroll;color:#ef5506;margin-top:10%;padding:0 6px;font-size:12px" :style="{'height': (ruleContentHeight-40) + 'px'}"></div> -->
        </div>
    </div>
    <!-- 我的奖品 -->
    <div class="displayCardList" :class="{'mask':true, 'display':displayPrize}" style="overflow-y: scroll;overflow-x: hidden;">
        <div class="" style="position:relative;height:100%">
            <div class="" :style="{'height': '100%'}" style="position:relative;">
                <img src="http://img.jacoo.cn/upload/feiyi2/choose_bg.png" style="width:100%" alt="">
                <div class="returnImg" style="top:9% !important">
                    <img src="http://img.jacoo.cn/upload/feiyi2/prize_back.png" style="width:40%" @click="closePrize" alt="">
                </div>
                <div v-if="awards.PrizeNum == 0" style="position:absolute;top:150px;width:100%;text-align:center">
                    <span class="awards-prompt" style="color: #333;">抱歉，您还没有中奖哟~</span>
                </div>
                <div class="step-content" v-else style="position:absolute;transform:none;top:0;z-index:99;">
                    <div class="prizeTitle" style="padding-top:20%;text-align:center">
                        <img src="http://img.jacoo.cn/upload/feiyi2/prize_title.png" style="width:40%" alt="">
                    </div>
                    <div class="awards-lst" ref="awards">
                        <div class="award" v-for="(award,index) in awards.Prizes" :key="index">
                            <div class="awardItem">
                                <div class="GoodsName">
                                    <div class="goodFlex">
                                        <div class="gName" style="color:#000;font-size:14px">{{award.GoodsName}}</div>
                                        <!-- <div class="gcode" v-if="award.CodeId !='' && award.GoodsType !='R'">
                                            <div class="gcodeLeft">兑换码：{{award.CodeId}}</div>
                                        </div> -->
                                        <!-- <div class="gcode" style="margin-top:2px" v-if="award.RecvDate !=''">
                                            <div class="gcodeLeft" style="color:#afafaf">{{award.RecvDate}}获得</div>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="awardsHandle" v-if="award.Status == 'A'">
                                    <a :href="award.RecvUrl"><img src="http://img.jacoo.cn/upload/feiyi2/prize_btn_recv.png" style="width:100%" alt=""></a>
                                </div>
                                <!-- <div v-else-if="award.Status == 'P'" class="awardsHandle gCopy" @click="showQRCode(award)">
                                    <img src="http://img.jacoo.cn/upload/feiyi2/prize_btn_consume.png" style="width:100%" alt="">
                                </div> -->
                                <div v-else class="awardsHandle hasget">
                                    <img src="http://img.jacoo.cn/upload/feiyi2/prize_btn_recved.png" style="width:100%" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="" style="margin-top:20px;padding:0 30px;">
                        <a href="javascript:;" @click="prizeAd"><img src="http://img.jacoo.cn/upload/scratch/prize_ad_1.png" alt="" style="width:100%"></a>
                    </div> -->
                    <div class="" style="margin-top:0px;overflow: scroll;padding-left:30px;padding-right:30px;position:relative">
                        <img src="http://img.jacoo.cn/upload/feiyi2/prize_tips.png" style="width:100%" alt="">
                        <div class="viewStep" @click="displayStep=true;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 新用户引导 -->
    <div :class="{'mask':true, 'display':displayNewUser}">
        <div class="returnImg" style="top:4% !important">
            <img src="http://img.jacoo.cn/upload/feiyi2/prize_back.png" style="width:30%" @click="displayNewUser = false" alt="">
        </div>
        <div class="content-large ">
            <div class="rule-content displayNewUser" :style="{'height': blessingContentHeight + 'px'}" style="padding:0">
                <div class="qrcodeImg" style="">
                    <img :src="displayNewUserBackground" style="width:90%;" />
                </div>
                <div style="margin-top:20px">
                    <p style="color:#fff;text-align: center;margin:0">↑ 长按上方图片保存，分享给好友，好友扫码参与活动视为助力成功，即可获得新的活动机会</p>
                </div>
            </div>
        </div>
    </div>
    <!-- <div :class="{'mask':true, 'display':displayNewUser}" style="overflow-y: hidden;overflow-x: hidden;background:linear-gradient(to right, #384615 60.8%, #40584a 50%);">
        <div style="height:100%">
            <img :src="displayNewUserBackground" style="width:100%;" />
            <div class="returnImg" style="top:6% !important">
                <img src="http://img.jacoo.cn/upload/feiyi2/prize_back.png" style="width:30%" @click="displayNewUser = false" alt="">
            </div>
            <div style="position:absolute;top:88%">
                <p style="color:#333;text-align: center;padding: 10px 20px;margin:0">↑ 长按上方图片保存，分享给好友，好友扫码参与活动视为助力成功，即可获得新的活动机会</p>
            </div>
        </div>
    </div> -->
    <!-- 兑换积分 -->
    <div :class="{'mask':true, 'display':displayStep}">
        <!-- <div class="returnImg">
            <img src="http://img.jacoo.cn/upload/feiyi2/prize_back.png" style="width:35%" @click="displayStep = false" alt="">
        </div> -->

        <div class="content-large ">
            <div class="contentBgStep" style="position:relative;height:100%;display: flex;align-items: center;">
                <img src="http://img.jacoo.cn/upload/feiyi2/prize_exchange_bg.png" alt="" style="width:100%">
            </div>
            <div class="close closeTop" @click="displayStep = false" style="top:-10%;right:10%">
            </div>
        </div>
    </div>
    <!-- 兑换积分 -->
    <div :class="{'mask':true, 'display':displayQRcode}">
        <div class="content-large ">
            <div class="" style="position:relative;height:100%;">
                <img src="http://img.jacoo.cn/upload/feiyi2/userInfo_bg.png" style="width:100%" alt="">
                <div class="nickNameInputItem" style="position:absolute;top:28%;left:32%">
                    <input placeholder="姓名" v-model="userName" maxlength="25" type="text" style="width:100%" />
                </div>
                <div class="nickNameInputItem" style="position:absolute;top:41%;left:32%">
                    <input placeholder="电话" v-model="mobile" maxlength="12" type="text" style="width:100%" />
                </div>
                <div class="bottomBtnImg" style="top:82%;width:100%;text-align:center">
                    <img src="http://img.jacoo.cn/upload/feiyi2/userInfo_save.png" alt="" style="width:35%;z-index:100" @click="submitUserInfo">
                </div>
            </div>
        </div>
    </div>
    <!-- 选择答案错误弹窗 -->
    <!-- <div :class="{'mask':true, 'display':displayAnsowerFail}">
        <div class="content-large ">
            <div class="" style="height:100%;position:relative">
                <img src="http://img.jacoo.cn/upload/feiyi2/ansower_fail.png" style="width:100%" alt="">
                <div class="closeFail">
                    <img src="http://img.jacoo.cn/upload/feiyi2/ansower_fail_btn.png" style="width:36%" @click="displayAnsowerFail = false" alt="">
                </div>
            </div>
        </div>
    </div> -->

</div>
</template>

<script>
/* eslint-disable */
import {
    Toast,
    Popup,
    Indicator,
    MessageBox,
    Field
} from 'mint-ui';
import Shake from 'shake.js';
import Vue from 'vue'
import {
    ImagePreview
} from 'vant';
import wx from 'weixin-js-sdk'
import Swiper from "swiper";
import Exif from 'exif-js'
import Jitter from '../../components/jitter';
import CricleTimer from './timer.vue'
import QRCode from 'qrcodejs2'
Vue.component(Field.name, Field);
Vue.component(Popup.name, Popup);
import SmoothSignature from "smooth-signature";
export default {
    components: {
        Jitter,
        CricleTimer,
        [ImagePreview.Component.name]: ImagePreview.Component,
    },
    data() {
        return {
            videoUrl: 'http://img.jacoo.cn/upload/feiyi2/video_01_01.mp4',
            homePoster: true,
            showHome: true,
            showTimer: false,
            startTime: 15,
            inviteFriend: false,
            viewRegister: false,
            viewInvest: false,
            scanQrcode: false,
            displayQRcode: false,
            taskList: [],
            lotteryId: '',
            userName: '',
            mobile: '',
            userId: '',
            joinId: '',
            playId: '',
            prizeId: '',
            RedpackUrl: "",
            challengesNum: 0,
            loading: false,
            showFalldown: false,
            displayMainContent: false,
            showLoading: true,
            displayMainPlayMp4: false,
            displayResult: false,
            displayRule: false,
            displayAuthor: false,
            displayGetCard: false,
            displayOpenCard: false,
            displayTask23: false,
            displayAnsowerFail: false,
            task23Img: '',
            AwardsimgShow: false,
            displayGetCardBackground: '',
            displayAwardsGif: '',
            star_falldownImg: 'http://img.jacoo.cn/upload/box/star_falldown.gif' + '?' + new Date().getTime(),
            Awardsimg: 'http://img.jacoo.cn/upload/feiyi2/win_bg.png',
            playAgainImg: '',
            myPriseImg: '',
            receiveImg: '',
            RecvUrl: '',
            showPrise: false,
            displayNewUserBackground: 'http://img.jacoo.cn/upload/feiyi2/bk.png',
            displayResultBackground: '',
            ruleContentHeight: 500,
            AuthorHeight: 500,
            blessingContentHeight: 500,
            blessingHeight: 500,
            Rule: '',
            title: '',
            shareTitle: '南京银行家与梦同行活动',
            imgUrl: '',
            displayLoading: true,
            progressActiveWidth: 0,
            userStatus: '',
            userPlayId: '',
            progressNum: 0,
            displayCardList: true,
            displayIntro: false,
            displayWhat: false,
            displayHelpCard: false,
            displayHelp: false,
            displayMakeCard: false,
            displaySeizeBag: false,
            displayCheats: false,
            cheatImg: '',
            cardList: [{
                    id: 1,
                    chooseImg: 'http://img.jacoo.cn/upload/feiyi2/choose_img_01.png',
                    infoImg1: 'http://img.jacoo.cn/upload/feiyi2/info_img_01_01.png',
                    infoImg2: 'http://img.jacoo.cn/upload/feiyi2/info_img_01_02.png',
                    resultImg: 'http://img.jacoo.cn/upload/feiyi2/result_img_01.png',
                },
                {
                    id: 2,
                    chooseImg: 'http://img.jacoo.cn/upload/feiyi2/choose_img_02.png',
                    infoImg1: 'http://img.jacoo.cn/upload/feiyi2/info_img_02_01.png',
                    infoImg2: 'http://img.jacoo.cn/upload/feiyi2/info_img_02_02.png',
                    resultImg: 'http://img.jacoo.cn/upload/feiyi2/result_img_02.png',
                }, {
                    id: 3,
                    chooseImg: 'http://img.jacoo.cn/upload/feiyi2/choose_img_03.png',
                    infoImg1: 'http://img.jacoo.cn/upload/feiyi2/info_img_03_01.png',
                    infoImg2: 'http://img.jacoo.cn/upload/feiyi2/info_img_03_02.png',
                    resultImg: 'http://img.jacoo.cn/upload/feiyi2/result_img_03.png',
                },
            ],
            mySwiper: null,
            displayCardBackground: 'http://img.jacoo.cn/upload/box/background.jpg',
            displayMainBackground: 'http://img.jacoo.cn/upload/silkbag/home_bg.jpg',
            displayCardListBackground: 'http://img.jacoo.cn/upload/silkbag/background.jpg',
            recordImg: 'http://img.jacoo.cn/upload/card/record.png',
            displayGetPrise: 'http://img.jacoo.cn/upload/silkbag/prize_win_bg.png',
            GroupQRCodeUrl: 'https://img.jacoo.cn/upload/luckycard/qrcode_bg.png',
            receiveLuckImg: '',
            main_title_width: 100,
            main_mechine_width: 95,
            awardsHeight: 350,
            dreamScale: false,
            dreamDown: false,
            dreamDown1: false,
            dreamDown2: false,
            showDream: false,
            showDreamBox: false,
            displayGetDumpling: false,
            displayTask: false,
            selectSilkbagId: '',
            dreamAnimation: '',
            userSilkbagList: [],
            silkbagList: [],
            seizeBagImg: '',
            centerBagImg: '',
            questions: [],
            questionNum: 1,
            resultImg: [],
            cheatItemImg1: '',
            cheatItemImg1Title: '',
            cheatItemImg2: '',
            cheatItemImg2Title: '',
            cheatTitle: '',
            successBagImg: '',
            helpBagImg: '',
            showHelpBtn: false,
            topAwardsTitleImg: '',
            displayMakeCardBackground: '',
            displayMakeCardBottomImg: '',
            cardFormHeight: 0,
            displaySuccess: false,
            displayStep: false,
            displayPrize: false,
            displayBlessing: false,
            displayReceiveBlessing: false,
            displayWechatCode: false,
            displayAwards: false,
            displayAwardsFail: false,
            displayCompleteCard: false,
            displayGraphic: false,
            displayNewUser: false,
            closeAward: false,
            shareGuideHeight: 0,
            shareGuideWidth: 0,
            awards: {},
            recordTimer: null,
            timeId: null,
            recordStartTime: 0,
            recordEndTime: 0,
            second: '00:00',
            voiceLocalId: null,
            recordText: '长按图标开始录音，录音最长60秒',
            cardForm: { //上传数据
                CardId: "309d10337f7d",
                JoinId: "",
                TemplateId: "",
                Content: "",
                VoiceId: "", // 测试用的serviceId
                VoiceContent: "",
                VoiceTime: 0,
                Picture: '',
            },
            playResult: {},
            lashIndex: null,
            integral: 588,
            ViewNum: 0,
            NickName: '',
            date: '',
            Content: '',
            VoiceTime: 0,
            VoiceTime1: 0,
            prizeImg: 'http://img.jacoo.cn/upload/card/zgj.png',
            GoodsType: 'V',
            GoodsDesc: '',
            audioUrl: '',
            showPic: true,
            timer: null,
            playTimer: null,
            isPlaying: false,
            currentTime: 0,
            serviceId: '',
            NumAvailable: 0,
            isShake: true,
            myShakeEvent: null,
            SHAKE_THRESHOLD: 1000,
            last_update: 0,
            x: 0,
            y: 0,
            z: 0,
            last_x: 0,
            last_y: 0,
            last_z: 0,
            doubleCheat: false,
            shareJoinId: '',
            showBtn: true,
            shareUser: '',
            ViewNum: 0,
            cheatNum: 0,
            lineWidth: 10,
            lineColor: '#000000',
            bgColor: '',
            resultImg: '',
            isCrop: true,
            AwardsName: '',
            signature: null,
            awardHeight: 500,
            openMyprise: '',
            userState: '',
            LuckyValue: 0,
            task1Status: '',
            task2Status: '',
            historyList: [],
            userCards: [],
            selectCardId: 0,
            infoNum: 1,
            isSkip: false
        }
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    mounted() {
        var _this = this
        _this.initSwiper();
        document.getElementById('media').loop = false // 不设置视频循环播放
        document.getElementById('media').addEventListener('ended', () => { //该视频播放是否已结束
            if (!this.isSkip) {
                if (_this.infoNum == 1) {
                    _this.displayResult = false
                    _this.infoNum = 2
                } else {
                    _this.displayResult = false
                    _this.displayIntro = false
                    _this.displayHelpCard = true
                }
            }
        }, false)
        // _this.Handwriting("canvasId");
        // 计算按钮部分高度
        setTimeout(() => {
            this.mainButtonTop = document.body.clientHeight - document.getElementById('headerimg').clientHeight - 5;
        }, 200)
        this.maskWrapperHeight = document.body.clientHeight;
        this.ruleContentHeight = document.documentElement.clientHeight * 0.7;
        this.AuthorHeight = document.documentElement.clientHeight * 0.5;
        this.blessingContentHeight = document.documentElement.clientHeight * 0.85;
        this.blessingHeight = document.documentElement.clientHeight * 0.7;
        this.awardHeight = document.documentElement.clientHeight * 0.55;
        this.stepContentHeight = document.documentElement.clientHeight * 0.9;
        // 海报高度
        var maxPosterWidth = document.body.clientWidth * 0.84;
        this.posterImgHeight = document.documentElement.clientHeight * 0.8 - 100;
        this.shareGuideWidth = document.body.clientWidth / 750 * 640 * 0.8;
        this.shareGuideHeight = document.body.clientHeight / 1334 * 648 * 0.8;
        if (this.posterImgHeight / 1334 * 750 > maxPosterWidth) {
            this.posterImgHeight = maxPosterWidth / 750 * 1334;
        }
        document.οncοntextmenu = function (e) {
            e.preventDefault();
        };

    },
    created() {
        this.joinId = this.$route.query.joinId;
        this.lotteryId = this.$route.query.lotteryId;
        if (this.$route.query.playId) {
            this.playId = this.$route.query.playId
            this.joinId = this.$route.query.joinId;
            this.spotGet();
            this.myPrise('home')
            return
        }
        if (this.$route.query.isShare) {
            this.displayCardList = false
            this.getViewUrl()
            return
        } else {
            this.spotGet();
            // setTimeout(() => {
            //     this.initShare();
            // }, 1500)
        }
    },
    methods: {
        Picturepreview() {
            var data = []
            data.push(this.resultImg)
            ImagePreview({
                images: data
            });
        },
        spotGet() {
            var url = 'http://cloud.jacoo.cn/api/v2/Lottery/Get?lotteryId=' + this.lotteryId + '&joinId=' + this.joinId
            this.$ajax.get(url)
                .then(res => {
                    this.loading = false;
                    if (res.data.RspMsg) {
                        Toast({
                            message: res.data.RspMsg,
                            position: 'middle',
                            duration: 3000
                        });
                    }
                    if (res.data.RspCode == 0) {
                        this.awards.RecvUrl = res.data.Data.User.RecvUrl;
                        var _this = this
                        this.joinId = res.data.Data.User.JoinId;
                        this.playId = res.data.Data.User.PlayId;
                        this.Rule = res.data.Data.Lottery.Rule;
                        this.title = res.data.Data.Lottery.LotteryName;
                        this.shareTitle = res.data.Data.Lottery.ShareTitle;
                        this.imgUrl = res.data.Data.Lottery.SharePic;
                        this.NumAvailable = res.data.Data.User.NumAvailable;
                        this.ViewNum = res.data.Data.Lottery.ViewNum
                        this.taskList = res.data.Data.User.UserTasks
                        // this.LuckyValue = res.data.Data.User.LuckyValue
                        this.initShare();
                        //  _this.cardList[0].Played = res.data.Data.User.UserCards[0].Played
                        //  _this.cardList[1].Played = res.data.Data.User.UserCards[1].Played
                        //  _this.cardList[2].Played = res.data.Data.User.UserCards[2].Played
                        // if (res.data.Data.User.UserCards && res.data.Data.User.UserCards.length > 0) {
                        //     res.data.Data.User.UserCards.forEach((item) => {
                        //         if (item.CardId == 'card0' && item.Selected == true) {
                        //             this.displayCardList = false
                        //             this.displayMakeCard = false
                        //             this.displayHelpCard = true
                        //             this.centerBagImg = this.cardList[0].resultImg
                        //         } else if (item.CardId == 'card1' && item.Selected == true) {
                        //             this.displayCardList = false
                        //             this.displayMakeCard = false
                        //             this.displayHelpCard = true
                        //             this.centerBagImg = this.cardList[1].resultImg
                        //         } else if (item.CardId == 'card2' && item.Selected == true) {
                        //             this.displayCardList = false
                        //             this.displayMakeCard = false
                        //             this.displayHelpCard = true
                        //             this.centerBagImg = this.cardList[2].resultImg
                        //         }
                        //     })
                        // }
                        this.showBtn = true
                        this.cheatNum = 0
                        console.log('抽奖次数:' + this.NumAvailable)
                        document.title = res.data.Data.Lottery.LotteryName;
                    } else {
                        Toast({
                            message: res.data.RspMsg,
                            position: 'middle',
                            duration: 3000
                        });
                    }
                })
                .catch(error => {
                    console.log(error)
                })

        },
        spotGet1() {
            this.selectCardId = 0
            this.infoNum = 1
            var url = 'http://cloud.jacoo.cn/api/v2/Lottery/Get?lotteryId=' + this.lotteryId + '&joinId=' + this.joinId
            this.$ajax.get(url)
                .then(res => {
                    this.loading = false;
                    if (res.data.RspMsg) {
                        Toast({
                            message: res.data.RspMsg,
                            position: 'middle',
                            duration: 3000
                        });
                    }
                    if (res.data.RspCode == 0) {
                        this.awards.RecvUrl = res.data.Data.User.RecvUrl;
                        var _this = this
                        this.joinId = res.data.Data.User.JoinId;
                        this.playId = res.data.Data.User.PlayId;
                        this.Rule = res.data.Data.Lottery.Rule;
                        this.title = res.data.Data.Lottery.LotteryName;
                        this.shareTitle = res.data.Data.Lottery.ShareTitle;
                        this.imgUrl = res.data.Data.Lottery.SharePic;
                        this.NumAvailable = res.data.Data.User.NumAvailable;
                        this.ViewNum = res.data.Data.Lottery.ViewNum
                        this.taskList = res.data.Data.User.UserTasks
                        // this.LuckyValue = res.data.Data.User.LuckyValue
                        this.initShare();
                        this.showBtn = true
                        this.cheatNum = 0
                        console.log('抽奖次数:' + this.NumAvailable)
                        document.title = res.data.Data.Lottery.LotteryName;
                        this.joinId = res.data.Data.User.JoinId;
                    } else {
                        Toast({
                            message: res.data.RspMsg,
                            position: 'middle',
                            duration: 3000
                        });
                    }
                })
                .catch(error => {
                    console.log(error)
                })

        },
        getViewUrl() {
            var _this = this
            _this.$ajax.get('http://cloud.jacoo.cn/api/v2/Lottery/GetViewUrl?joinId=' + this.joinId)
                .then(function (rsp) {
                    console.log(rsp);
                    if (rsp.data.RspCode < 0) {
                        Toast({
                            message: rsp.data.RspMsg,
                            position: 'middle',
                            duration: 3000
                        });
                        return;
                    }
                    if (rsp.data.Data) {
                        window.location.href = rsp.data.Data;
                        return;
                    }
                });
        },
        prev() {
            this.mySwiper.slidePrev();
        },
        next() {
            this.mySwiper.slideNext();
        },
        initSwiper() {
            if (this.mySwiper != null) {
                return;
            }
            this.mySwiper = new Swiper(".swiper-container", {
                direction: "horizontal",
                loop: true,
                initialSlide: 0,
                slidesPerView: 'auto',
                allowTouchMove: true,
                navigation: {
                    prevEl: '.swiper-button-prev',
                    nextEl: '.swiper-button-next',
                },
                centeredSlides: true,
                // spaceBetween: -30,
                pagination: { // 分页器
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                observer: true,
                observeParents: true,
            });
        },
        toVedio() {
            window.location.href = 'https://img.jacoo.cn/upload/feiyi2/video.m4v'
        },
        videoPlay() {
            var audio = document.getElementById('media');
            audio.src = this.videoUrl;
            audio.load();
            audio.play();
            audio.pause();
            audio.play();
            document.addEventListener("wxReady", function () {
                audio.play();
            }, false);
            //监听audio播放完毕
            audio.addEventListener('ended', function () {
                if (!this.isSkip) {
                    if (this.infoNum == 1) {
                        this.displayResult = false
                        this.infoNum = 2
                    } else {
                        this.displayResult = false
                        this.displayIntro = false
                        this.displayHelpCard = true
                    }
                }
            }, false);
        },
        viewMp41() {
            this.isSkip = false
            if (this.selectCardId == 0) {
                this.videoUrl = 'http://img.jacoo.cn/upload/feiyi2/video_01_01.mp4'
            } else if (this.selectCardId == 1) {
                this.videoUrl = 'http://img.jacoo.cn/upload/feiyi2/video_02_01.mp4'
            } else {
                this.videoUrl = 'http://img.jacoo.cn/upload/feiyi2/video_03_01.mp4'
            }
            this.displayResult = true
            this.videoPlay()
        },
        viewMp42() {
            this.isSkip = false
            if (this.selectCardId == 0) {
                this.videoUrl = 'http://img.jacoo.cn/upload/feiyi2/video_01_02.mp4'
            } else if (this.selectCardId == 1) {
                this.videoUrl = 'http://img.jacoo.cn/upload/feiyi2/video_02_02.mp4'
            } else {
                this.videoUrl = 'http://img.jacoo.cn/upload/feiyi2/video_03_02.mp4'
            }
            this.displayResult = true
            this.videoPlay()
        },
        skip() {
            this.isSkip = true
            this.displayResult = false
            if (this.infoNum == 1) {
                this.infoNum++
            } else {
                this.displayIntro = false
                this.displayHelpCard = true
            }
        },
        //开启好运
        dreamClick() {
            if (this.NumAvailable <= 0) {
                this.homePoster = true
                this.smSave('home')
                return
            } else {
                this.displayAwards = false
                this.displayCardList = false
                this.displayMakeCard = true;
            }
        },
        prevQuestion(item) {
            this.questionNum -= 1
        },
        nextQuestion(item) {
            if (item.isCorrect) {
                this.questionNum += 1
            } else {
                Toast({
                    message: '请选择正确答案',
                    position: 'middle',
                    duration: 3000
                });
                return;
            }
        },
        selectCorrectA(item) {
            item.isCorrect = true
        },
        intrStart(item) {
            if (item.isCorrect != true) {
                Toast({
                    message: '请选择正确答案',
                    position: 'middle',
                    duration: 3000
                });
                return;
            }
            this.displayIntro = false
            var _this = this;
            const type = this.mySwiper.realIndex > 2 ? 0 : this.mySwiper.realIndex
            _this.$ajax.get('http://cloud.jacoo.cn/api/v2/Lottery/ResultPoster?joinId=' + this.joinId + '&type=' + _this.cardList[type].id)
                .then(function (rsp) {
                    console.log(rsp);
                    if (rsp.data.RspCode < 0) {
                        Toast({
                            message: rsp.data.RspMsg,
                            position: 'middle',
                            duration: 3000
                        });
                        return;
                    }
                    _this.displayResultBackground = rsp.data.Data;
                    _this.displayHelpCard = true;
                });
            // this.displayHelpCard = true
        },
        //选择福气卡
        confirmSelect() {
            var _this = this;
            _this.selectCardId = this.mySwiper.realIndex > 2 ? 0 : this.mySwiper.realIndex
            _this.resultImg = _this.cardList[_this.selectCardId].resultImg
            _this.infoNum = 1
            console.log(this.mySwiper.realIndex)
            let cardId = 'card' + _this.selectCardId
            var _this = this
            _this.displayMakeCard = false
            _this.displayIntro = true;
        },
        closeNewUser() {
            this.displayNewUser = false
        },
        //再玩一次
        playAgain() {
            this.displayAwards = false
            this.displayAwardsFail = false
            this.displayMakeCard = false
            this.displayHelpCard = false
            this.displayCardList = true
            this.openMyprise = ''
            this.spotGet1()
        },
        //保存海报
        history() {
            var _this = this;
            _this.$ajax.get('http://cloud.jacoo.cn/api/v2/Lottery/History?joinId=' + this.joinId)
                .then(function (rsp) {
                    console.log(rsp);
                    if (rsp.data.RspCode < 0) {
                        Toast({
                            message: rsp.data.RspMsg,
                            position: 'middle',
                            duration: 3000
                        });
                        return;
                    }
                    _this.historyList = rsp.data.Data
                    _this.displayWhat = true
                });
        },
        //保存海报
        smSave(item) {
            if (item == 'home') {
                var _this = this;
                _this.$ajax.get('http://cloud.jacoo.cn/api/v2/Lottery/poster?joinId=' + this.joinId)
                    .then(function (rsp) {
                        console.log(rsp);
                        if (rsp.data.RspCode < 0) {
                            Toast({
                                message: rsp.data.RspMsg,
                                position: 'middle',
                                duration: 3000
                            });
                            return;
                        }
                        _this.displayNewUserBackground = rsp.data.Data;
                        _this.displayNewUser = true;
                    });
            } else {
                var _this = this;
                const type = this.mySwiper.realIndex > 2 ? 0 : this.mySwiper.realIndex
                _this.$ajax.get('http://cloud.jacoo.cn/api/v2/Lottery/poster?joinId=' + this.joinId + '&type=' + _this.cardList[type].id)
                    .then(function (rsp) {
                        console.log(rsp);
                        if (rsp.data.RspCode < 0) {
                            Toast({
                                message: rsp.data.RspMsg,
                                position: 'middle',
                                duration: 3000
                            });
                            return;
                        }
                        _this.displayNewUserBackground = rsp.data.Data;
                        _this.displayNewUser = true;
                    });
            }

        },
        showQRCode(award) {
            const _this = this
            this.displayQRcode = true
            this.$nextTick(() => {
                _this.$refs.qrCodeUrl.innerHTML = "";
                var qrcode = new QRCode(_this.$refs.qrCodeUrl, {
                    text: 'http://cloud.jacoo.cn/panel/consume?t=Lottery&p=' + award.PlayId, //二维码内容
                    width: window.document.body.clientWidth > 375 ? 163 : 150,
                    height: window.document.body.clientWidth > 375 ? 163 : 150,
                    render: 'table',
                    colorDark: "#3f3f3f", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.H //容错率，L/M/H
                })
            })
        },
        //抽奖
        smLottery() {
            var _this = this;
            const type = this.mySwiper.realIndex > 2 ? 0 : this.mySwiper.realIndex
            _this.$ajax.get('http://cloud.jacoo.cn/api/v2/Lottery/play?joinId=' + _this.joinId + '&type=' + _this.cardList[type].id)
                .then(function (rsp) {
                    if (rsp.data.RspCode < 0) {
                        Toast({
                            message: rsp.data.RspMsg,
                            position: 'middle',
                            duration: 3000
                        });
                        return;
                    }
                    _this.selectCardId = 0
                    _this.infoNum = 1
                    _this.displayResult = false
                    _this.playId = rsp.data.Data.PlayId;
                    _this.Awardsimg = rsp.data.Data.GoodsPic;
                    _this.AwardsName = rsp.data.Data.GoodsName
                    if (rsp.data.Data.GoodsType == 'E') {
                        _this.displayAwardsFail = true
                    } else {
                        _this.Awardsimg = rsp.data.Data.GoodsPic
                        _this.displayAwards = true
                    }
                });
        },
        closePrize() {
            var _this = this;
            if (_this.openMyprise == 'home') {
                _this.displayCardList = true
                _this.displayPrize = false
                _this.spotGet1()
            } else if (_this.openMyprise == 'intro') {
                _this.displayPrize = false
                _this.displayIntro = true
            } else if (_this.openMyprise == 'MakeCard') {
                _this.displayPrize = false
                _this.displayMakeCard = true
            } else if (_this.openMyprise == 'HelpCard') {
                _this.displayPrize = false
                _this.displayHelpCard = true
            } else {
                _this.displayPrize = false
                _this.displayCardList = false
                _this.displayMakeCard = true
            }
        },
        submitUserInfo() {
            let _this = this;
            if (_this.mobile == '' || _this.userName == '') {
                Toast({
                    message: '请完善信息',
                    position: 'middle',
                    duration: 3000
                });
                return
            }
            this.$ajax.post('http://cloud.jacoo.cn/api/NewLottery/SaveUserInfo?joinId=' + _this.joinId + '&playId=' + _this.playId + '&userName=' + _this.userName + '&tel=' + _this.mobile)
                .then((rsp) => {
                    if (rsp.data.RspCode < 0) {
                        Toast({
                            message: rsp.data.RspMsg,
                            position: 'middle',
                            duration: 3000
                        });
                        return;
                    }
                    _this.displayQRcode = false
                    _this.myPrise('home')
                    // _this.displayCardList = true
                    // _this.smLottery(_this.type)
                    // _this.getRecvPrize(_this.playId)
                })
        },
        //我的奖品
        myPrise(item) {
            var _this = this;
            _this.openMyprise = item
            _this.displayAwards = false;
            _this.displayAwardsFail = false;
            _this.displayInput = false
            _this.displayPrize = true;
            _this.$ajax.get('https://cloud.jacoo.cn/api/v2/Lottery/Prizes?joinId=' + this.joinId)
                .then(function (rsp) {
                    console.log(rsp);
                    if (rsp.data.RspCode < 0) {
                        Toast({
                            message: res.data.RspMsg,
                            position: 'middle',
                            duration: 3000
                        });
                        return;
                    }
                    rsp.data.Data.Prizes = rsp.data.Data.Prizes.slice(0, 2)
                    _this.awards = rsp.data.Data;
                    // if (_this.awards.RegUrl && _this.awards.RegUrl != null && _this.awards.RegUrl != "") {
                    //   window.location.href = _this.awards.RegUrl;
                    //   return;
                    // } else {
                    _this.displayPrize = true;
                    if (_this.$route.query.playId) {
                        const currPrize = rsp.data.Data.Prizes.find((prize) => {
                            return prize.PlayId == _this.playId
                        })
                        if (currPrize) {
                            if (currPrize.GoodsType == 'Q' && currPrize.Status != 'C') {
                                // _this.showQRCode(currPrize)
                                _this.displayQRcode = true
                            }
                        }
                    }

                    // }
                });
        },
        initShare() {
            var url = encodeURIComponent(location.href);
            var _this = this;
            var title = _this.shareTitle;
            var imgUrl1 = _this.imgUrl;
            var link = window.location.href.split('feiyi2')[0] + 'feiyi2?joinId=' + _this.joinId + '&lotteryId=' + _this.lotteryId + '&isShare=true';
            console.log(title)
            console.log(link)
            console.log(imgUrl1)
            this.$ajax.get('https://cloud.jacoo.cn/api/weixin/getsign?url=' + url).then((res) => {
                this.AppId = res.data["AppId"]
                this.Timestamp = res.data["Timestamp"]
                this.NonceStr = res.data["NonceStr"]
                this.Signature = res.data["Signature"]
                wx.config({
                    debug: false,
                    appId: res.data["AppId"],
                    timestamp: res.data["Timestamp"],
                    nonceStr: res.data["NonceStr"],
                    signature: res.data["Signature"],
                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', ]
                })

            }).catch((error) => {
                console.log(error)
            });

            wx.ready(function () {
                console.log(title)
                console.log(link)
                console.log(imgUrl1)

                wx.onMenuShareTimeline({
                    title: title, // 分享标题
                    link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: imgUrl1, // 分享图标(不能赋相对路径，一定要是绝对路径)
                    success: () => {

                    }
                })
                wx.onMenuShareAppMessage({
                    title: title, // 分享标题
                    desc: '', // 分享描述
                    link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: imgUrl1, // 分享图标
                    success: () => {

                    }
                })
                wx.hideMenuItems({
                    menuList: [
                        'menuItem:openWithSafari',
                        'menuItem:share:email',
                        'menuItem:openWithQQBrowser',
                        'menuItem:share:qq',
                        'menuItem:share:weiboApp',
                        'menuItem:share:QZone',
                        //'menuItem:copyUrl',
                        'menuItem:readMode',
                    ] // 
                });
            });
            wx.error(function (res) {});

        },
        //手写
        //重置
        reset() {

        }
    }
}
</script>

<style>
/* @import  '../../assets/style/font.css'; */

body {
    /* background: url('http://img.jacoo.cn/upload/family/main_bg.jpg'); */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    font-size: 14px !important;
    overflow: hidden;
    /* background: #fcda6c; */
}

#app {}

.mainPage {
    position: relative;
}

.mainContent {
    width: 100%;
    height: 100%;
}

.main_title {
    position: absolute;
    top: 15%;
    width: 100%;
    text-align: center;
    z-index: 3;
}

.bottomMountain {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    z-index: 3;
}

.choose_duck {
    position: absolute;
    top: 60%;
    left: 20%;
    width: 100%;
    text-align: center;
    z-index: 3;
}

.btn_skip {
    position: absolute;
    top: 5%;
    right: 5%;
}

.rightBtn {
    position: absolute;
    top: 3%;
    right: 5%;
    text-align: center;
}

.main_mechine {
    position: absolute;
    top: 30%;
    width: 100%;
    text-align: center;
}

.hasUser {
    position: absolute;
    top: 95%;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
}

.hasuserBg {
    /* width: 59%; */
    color: #fff;
    /* background: rgba(0, 0, 0, 0.5); */
    /* border-radius: 20px; */
    /* background-size: 100% 100%; */
    padding: 5px 5px;
    font-size: 12px;
}

.btn_play {
    position: absolute;
    top: 80%;
    text-align: center;
    width: 100%;
    /* padding-left: 6px; */
}

.btn_back {
    position: absolute;
    top: 77%;
    text-align: center;
    right: 0;
}

.main_plate {
    position: absolute;
    top: 67%;
    text-align: center;
    width: 100%;
}

.main_lights {
    position: absolute;
    top: 27%;
    text-align: center;
    width: 100%;
}

.centerBagandCheats {
    position: absolute;
    top: 40%;
    width: 100%;
    text-align: center;
}

.ReasultImg {
    position: absolute;
    top: 47%;
    width: 100%;
    text-align: center;
}

.canvasWrite {
    position: absolute;
    top: 20%;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 3;
}

.leftBG {
    position: absolute;
    width: 23%;
    left: 0;
    top: 0;
    height: 200px;
    z-index: 4;
}

.rightBG {
    position: absolute;
    width: 27%;
    height: 200px;
    z-index: 4;
    right: 0;
    top: 0;
}

.canvasWriteCard {
    width: 100%;
    height: 100%;
}

.centerBag {}

.cheats {
    display: flex;
    /* align-items: center; */
}

.cheatItem {
    width: 50%;
    text-align: center;
}

.helpTitle {
    font-size: 30px;
    font-weight: bold;
    line-height: 35px;
    color: #E76251;
}

.cheatItemImg1Title,
.cheatItemImg2Title {
    color: #E76251;
    font-size: 12px;
}

.helpSupTitle {
    font-size: 16px;
    line-height: 22px;
    color: #E76251;
    font-weight: bold;
}

.helpSupTitle1 {
    font-size: 14px;
    line-height: 22px;
    color: #E76251;
    font-weight: bold;
    letter-spacing: 1px;
}

.dreamList {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 32%;
    /* position: relative; */
    height: 100%;
}

.dreamListDec {
    font-size: 12px;
    color: #fff;
    padding: 7px 0px 5px;
    /* transform: scale(0.9); */
    /* background:#222848; */
}

.dreamItem {
    /* margin-top: 5px; */
    /* display: flex;
  align-items: center;
  justify-content: center; */
    width: 100%;
    text-align: center;
}

input::-webkit-input-placeholder {
    color: #fff;
}

input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #fff;
}

input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #fff;
}

input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #fff;
}

.dreamTitleBg input:focus-visible {
    border: none;
    background: none;
    outline: none;
}

.main_plate_bg {
    display: flex;
    justify-content: center;
    align-items: center;
    top: 66%;
}

.star_falldown {
    position: absolute;
    top: 0%;
    width: 100%;
}

.boxTitle {
    text-align: center;
}

.display {
    display: block !important;
}

.hide {
    display: none;
}

.mask {
    display: none;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    /* background: none !important; */
    background: rgba(0, 0, 0, 0.8);
    z-index: 999;
}

.mask .mask-wrapper {
    position: relative;
}

.mask .content {
    width: 70%;
    margin: 10% auto 0px auto;
    border-radius: 5px;
    padding: 20px;
    position: relative;
}

.closeTop img {
    position: absolute;
    top: 8px;
    right: 8px;
}

.mask .content-large {
    width: 84%;
    /* margin-top: 10%; */
    /* min-height: 80%; */
    padding: 0% 8%;

    position: absolute;
    top: 50%;
    transform: translateY(-50%);

}

.luckyValue {
    position: absolute;
    top: 7%;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    width: 100%;
}

.ruleBtn {
    /* padding: 3px 15px;
    color: #fff; */
    /* border: 1px solid #fff; */
    /* border-radius: 12px; */
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.priseBtn {
    /* padding: 3px 15px;
    color: #fff; */
    /* border: 1px solid #fff;
    border-radius: 12px; */
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.contentBg {
    background: url('https://img.jacoo.cn/upload/luckycard/rule_bg.png') no-repeat center center;
    background-size: 100% 100%;
    border-radius: 10px;
}

.ruleBg {
    background: url('https://img.jacoo.cn/upload/luckycard/rule_bg.png') no-repeat center center;
    background-size: 100% 100%;
    border-radius: 10px;
}

.contentBgMyPrize {
    background: url('https://img.jacoo.cn/upload/artist/prize_bg.jpg') no-repeat center center;
    background-size: 100% 100%;
    border-radius: 0px;
}

.contentBgStep {
    /* background: url('https://img.jacoo.cn/upload/artist/prize_bg.jpg') no-repeat center center; */
    background-size: 100% 100%;
    border-radius: 0px;
}

.contentBg1 {
    background: url('http://img.jacoo.cn/upload/family/window_exchange_bg.png') no-repeat center center;
    background-size: 100% 100%;
}

.awardWinBg {
    background: url('http://img.jacoo.cn/upload/family/window_win_bg.png') no-repeat center center;
    background-size: 100% 100%;
}

.awardFailBg {
    background: url('http://img.jacoo.cn/upload/family/window_sorry_bg.png') no-repeat center center;
    background-size: 100% 100%;
}

.getPrise {
    text-align: center;
}

.displayNewUser {
    background-repeat: no-repeat !important;
    background-size: 100% !important;
}

.graphicContent {
    top: 5% !important;
    transform: translateY(-5%) !important;
}

.mask .rule-content {
    /* overflow: scroll; */
    color: #333;
    font-size: 14px;
    border-radius: 5px;
    padding: 20px 15px 15px;
    position: relative;
}

.ruleTitle {
    font-size: 20px;
    color: #333;
    line-height: 40px;
    text-align: center;
}

.logoImg {
    position: absolute;
    top: 5%;
    width: 100%;
    text-align: center;
}

.subTitle {
    font-size: 12px;
    color: #fff;
    line-height: 40px;
    text-align: center;
}

.shareImg {
    text-align: center;
}

.shareImg img {
    /* width: 70%; */
    margin: auto;
    border-radius: 8px;
}

.shareMsg {
    font-size: 0.4rem;
    color: #fff;
    margin-top: 20px;
    padding: 0 30px;
}

.btn-recv {
    width: 150px;
    height: 34px;
    background: #ff592d;
    line-height: 34px;
    text-align: center;
    border-radius: 24px;
    margin: 15px auto;
    display: block;
    color: #fff;
}

.recv-rule {
    color: #fff;
    text-align: left;
    font-size: 14px;
    padding: 20px 10px 0;
}

.recv-rule a,
.rule-content a,
.step-content a,
.notReceive a,
.bag-prompt a {
    text-decoration: underline;
    color: #F7D746;
}

.loading {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    text-align: center;
    display: inline-block;
    font-size: 26px;
    color: rgba(200, 200, 200, 0.5);
}

[class*="loader"] {
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-top: -0.5em;
    color: inherit;
    vertical-align: middle;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.loader {
    border: .2em solid transparent;
    border-top-color: currentcolor;
    border-radius: 50%;
    -webkit-animation: 1s loader linear infinite;
    animation: 1s loader linear infinite;
    position: relative;
}

.loader:before {
    content: '';
    display: block;
    width: inherit;
    height: inherit;
    position: absolute;
    top: -.2em;
    left: -.2em;
    border: .2em solid currentcolor;
    border-radius: 50%;
    opacity: .5;
}

.mask {
    display: none;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 999;
}

.mask .mask-wrapper {
    position: relative;
    /* margin: 10% auto 0px auto; */
    -webkit-transform: translateX(-50%) translateY(-50%);
    top: 50%;
    left: 50%;
}

.mask .mask-wrapper .title {
    padding: 0px;
    margin: 0px;
    width: 100%;
    text-align: center;
    position: absolute;
    color: #fff;
    font-size: 30px;
    white-space: nowrap;
    top: -25px;
    text-shadow: 0px 3px 0px #4DAA73;
    -webkit-text-stroke: 1px #000;
    z-index: 999;
    font-family: Source Han Sans CN;
}

.mask .close {
    position: absolute;
    display: block;
    width: 30px;
    height: 30px;
    top: 15px;
    right: 5px;
    background-size: 100% 100%;
    background-image: url('https://img.jacoo.cn/upload/luckycard/icon_close.png');
    z-index: 9999
}

.mask .mask-wrapper .content {
    border-radius: 10px;
    box-shadow: 0px 0px 0px 2px #282d2d, 8px 8px 0px 5px #4ca972, 8px 8px 0px 7px #282d2d;
    background-image: url('http://img.jacoo.cn/upload/garbage/result_background.jpg');
    background-repeat: repeat;
    width: 50%;
    border-radius: 5px;
    padding: 20px;
    margin: auto;
    position: relative;
}

.display {
    display: block !important;
}

.displayCardList {
    background-image: url('http://img.jacoo.cn/upload/feiyi2/repeatBg.jpg');
    background-repeat: repeat;
}

.cheatTitle {
    position: absolute;
    top: 24%;
    left: 0;
    width: 100%;
    text-align: center;
}

.cheatTitle p {
    color: #E76251;
    margin: 0;
    text-align: center;
}

.contentImg {
    position: absolute;
    top: 34%;
    left: 0;
    width: 100%;
    z-index: 99;
    text-align: center;
}

.topTitleImg {
    position: absolute;
    top: 8%;
    left: 0;
    width: 100%;
    z-index: 99;
    text-align: center;
}

.bottomImg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}

.bottomImg img {
    width: 100%;
}

.handle {
    position: absolute;
    bottom: 10%;
}

.returnImg {
    position: absolute;
    left: 0% !important;
    top: 5% !important;
    z-index: 100;
}

.useBk {
    /* position: absolute;
  bottom: 5%; */
    /* display: flex;
  justify-content: center; */
    text-align: center;
    padding-bottom: 10px;
}

.activityBtn {
    display: flex;
    justify-content: center;
}

.btnList {
    display: flex;
    width: 60%;
}

.btnList div {
    width: 50%;
    display: flex;
    justify-content: center;
    padding: 0 10px;
}

.makeCard {
    position: relative;
    height: 100%;
    overflow: hidden;
    background: url('http://img.jacoo.cn/upload/dream/lights.png') center no-repeat;
    background-size: 100% 100%;
}

.makeCard1 {
    position: relative;
    height: 100%;
    overflow: hidden;
}

.open {
    position: absolute;
    /* bottom: 10%; */
    top: 402px;
    left: 0;
    width: 100%;
    height: 50px;
}

.felx {
    display: flex;
    align-items: center;
}

.flexItem {}

.flexItemTitle {
    color: #F6463E;
    font-size: 14px;
}

.flexBtn {
    font-size: 14px;
    background: rgba(246, 70, 62, 0.4);
    border-radius: 20px;
    padding: 4px 10px;
    color: #F6463E;
    margin: 0 2px;
}

.makeCardBtn {
    /* display: flex;
  justify-content: center; */
    position: absolute;
    top: 60%;
    transform: translateY(-60%);
    width: 100%;
    z-index: 100;
    text-align: center;
}

.file_imgs {
    position: absolute;
    top: 0;
    opacity: 0;
    height: 40px;
}

.step-content {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    left: 0;

}

.awardsHandle {
    text-align: center;
    color: #fff;
    font-size: 12px;
    /* position: absolute;
    bottom: 29%; */
    /* left: 0; */
    width: 100px;
}

.viewStep {
    position: absolute;
    bottom: 15%;
    left: 45%;
    color: #000;
    font-size: 14px;
    width: 100px;
    height: 40px;
}

.step-content p {
    font-size: 12px;
    margin: 0;
    line-height: 16px;
    color: #333;
}

.exchange p {
    line-height: 18px;
}

.notReceive p {
    font-size: 12px;
    margin: 0;
    line-height: 16px;
    color: #fff;
}

.qrcodeImg {
    display: flex;
    padding-top: 20px;
    justify-content: center;
    align-items: center;
}

.awards-lst {
    padding: 0 30px 0;
    padding-top: 2%;
    max-height: 225px;
    overflow: scroll;
}

.awardItem {
    background: url('http://img.jacoo.cn/upload/feiyi2/goods_bg.png') no-repeat center center;
    background-size: 100% 100%;
    padding: 0 10px 0 15px;
    font-size: 12px;
    border-radius: 10px;
    color: #000;
    position: relative;
    height: 50px;
    display: flex;
    align-items: center;
}

.award {
    margin-bottom: 10px;
    /* margin: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 33.33%;
    position: relative; */
}

.GoodsName {
    width: 100%;
    border-radius: 1px;
    color: #666;
    font-size: 12px;
    text-align: left;
    /* line-height: 40px; */
    display: flex;
    align-items: center;
    height: 100%;
    /* border: 3px solid #000; */
}

.goodFlex {
    width: 100%;
}

.gcode {
    display: flex;
    align-items: center;
}

.gcodeLeft {
    width: 100%;
    font-size: 12px;
    color: #697bfb;
    /* transform: scale(0.9); */
}

.gcodeRight {
    width: 120px;
    display: flex;
    align-items: center;
    margin-right: 48px;
}

.gCopy {
    /* padding: 1px 5px; */
    /* border: 1px solid #ffe7d2; */
    color: #ff8346;
    /* border-radius: 10px; */
    font-size: 12px;
}

.receive {
    width: 60px;
    text-align: center;
    display: flex;
    align-items: center;
    padding-left: 5px;
}

.Awardsimg {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 58%;
    transform: translateY(-50%);
    left: 0%;
}

.AwardsName {
    position: absolute;
    top: 48%;
    left: 0%;
    width: 100%;
    text-align: center;
}

.AwardsNameBg {
    color: #fff;
    position: absolute;
    top: 3px;
    width: 100%;
    text-align: center;
}

.makeCradBtn {
    display: flex;
    justify-content: center;
    width: 50%;
}

.topImg {
    position: absolute;
    top: 26%;
    text-align: center;
    left: 0;
}

.receiveImg {
    position: absolute;
    top: 80%;
    text-align: center;
    left: 0;
}

.ruleImg {
    position: absolute;
    top: 5%;
    right: 8px;
    /* display: flex;
  align-items: center; */
    text-align: right;
    z-index: 99;
}

.bottomBtnImg {
    position: absolute;
    left: 0;
    z-index: 99;
}

.author {
    padding: 10px 20px;
    border: 1px solid #FFDC3A;
    border-radius: 20px;
}

.authorBtn {
    display: flex;
    justify-content: center;
    padding-top: 20px;
}

.mint-popup {
    width: calc(100% + 1px);
    background: none !important;
}

.popupContent {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background: #fff3dd;
}

.popup {
    padding-top: 30px;
    position: relative;
}

.popupTask {
    padding: 20px 0 20px;
}

.popupHeader {
    position: absolute;
    top: -6.4%;
    width: 100%;
    text-align: center;
}

.closePopup {
    position: absolute;
    right: 20px;
    top: 10px;
}

.closePopup img {
    width: 20px;
    height: 20px;
}

.taskItem {
    display: flex;
    margin: 20px 15px 0;
    background: #fff;
    border-radius: 8px;
    padding: 10px 5px;
}

.taskIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
}

.taskNameInfo {
    display: flex;
    align-items: center;
    width: 105%;
    padding-left: 5px;
}

.taskName {
    color: #650000;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
}

.taskNameDec {
    color: #999999;
    font-size: 12px;
    line-height: 18px;
}

.taskBtnInfo {
    width: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.prize_popup {
    width: 100% !important;
    padding: 0 !important;
    background: #fff;
    height: 100%;
}

.prize_popup .close {
    position: absolute;
    top: 5%;
    right: 0;
}

.taskBtn {
    padding: 0 10px;
    border-radius: 15px;
    background: #FF7143;
    color: #fff;
    height: 30px;
    line-height: 30px;
    display: flex;
    align-items: center;
}

.continue {
    font-size: 12px;
}

.taskBtnDec {
    display: flex;
    align-items: center;
}

.mine {
    display: block;
    padding-top: 10px;
    width: 70%;
    margin: 0 auto;
}

.timer15 {
    position: fixed;
    top: 10%;
    right: 0;
    z-index: 1000;
}

input::-webkit-input-placeholder {
    color: #372408;
    font-size: 12px;
    -webkit-transform-origin-x: 0;
    /* -webkit-transform: scale(0.72);
    transform-origin: left;
    width: 300%; */
}

input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #372408;
    font-size: 12px;
    -webkit-transform-origin-x: 0;
    /* transform: scale(0.72);
    transform-origin: left;
    width: 300%; */
}

input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #372408;
    font-size: 12px;
    -webkit-transform-origin-x: 0;
    /* transform: scale(0.72);
    transform-origin: left;
    width: 300%; */
}

input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #372408;
    font-size: 12px;
    -webkit-transform-origin-x: 0;
    /* transform: scale(0.72);
    transform-origin: left;
    width: 300%; */
}

.nickNameInputItem input {
    background: none;
    border: none;
    border-width: 1px;
    line-height: 37px;
    padding-left: 10px;
    color: #333;
}

.nickNameInputItem input:focus-visible {
    border: none;
    background: none;
    outline: none;
}

.questions {
    position: absolute;
    top: 15%;
    width: 100%;
}

.questionTopTip {
    text-align: center;
}

.questionNumList {
    display: flex;
    justify-content: center;
    margin-top: 3%;
}

.questionNumList img {
    margin: 0 10px;
}

.questionImg {
    position: relative;
    margin: 0 16%;
    margin-top: 3%;
    text-align: center;
}

.magnifier {
    position: absolute;
    right: -9%;
    bottom: -5%;
    z-index: 3;
}

.questionTitle {
    margin: 0 10%;
    margin-top: 5%;
}

.ansowerList {
    margin-top: 5%;
}

.closeFail {
    position: absolute;
    bottom: 12%;
    text-align: center;
    width: 100%;
}

.swiperContent {
    position: absolute !important;
    left: 0%;
    top: 50%;
    transform: translateY(-52%);
    width: 100%;
}

.swiper-container {
    width: 100%;
    height: 300px;
    overflow: visible !important;
    --swiper-navigation-color: #00ff33;
    /* 单独设置按钮颜色 */
    --swiper-navigation-size: 30px;
    /* 设置按钮大小 */
    /* margin-left: 8px; */
}

.swiper-button-next {
    position: absolute;
    top: 113%;
    right: 5%;
    transform: translateY(-50%);
    z-index: 4;
    text-align: right;
    width: 60px;
}

.swiper-button-prev {
    position: absolute;
    top: 113%;
    left: 5%;
    transform: translateY(-50%);
    z-index: 4;
    width: 60px;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100% !important;
    /* transform: scale(0.8); */
    z-index: 1;
    position: relative;
    opacity: 0;
}

.swiper-slide-next {
    margin-right: 0 !important;
    opacity: 1;
}

.swiper-slide-prev {
    opacity: 1;
}

.swiper-slide .cardItemMask {
    position: absolute;
    left: 13%;
    top: 0;
    display: block;
    width: 68%;
    height: 91%;
    background-color: rgba(0, 0, 0, 0.5);
}

.swiper-slide img {
    width: 100%;
}

.swiper-slide-active {
    z-index: 3 !important;
    /* transform: scale(1.5) !important; */
    opacity: 1;
}

.swiper-slide-active .cardItemMask {
    opacity: 0;
}

.swiper-slide-active .swiper-slide-item {
    /* margin-left: 5px; */
}

.chooseTitle {
    position: absolute;
    top: -35%;
}

@keyframes downDraw {

    /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
    0% {
        transform: none;
        /*开始为原始大小*/
    }

    100% {
        transform: scale(1.2);
        /*放大1.1倍*/
    }
}

.dreamDown {
    -webkit-animation-name: downDraw;
    /*关键帧名称*/
    -webkit-animation-timing-function: ease-in-out;
    /*动画的速度曲线*/
    -webkit-animation-iteration-count: infinite;
    /*动画播放的次数*/
    -webkit-animation-duration: 0.8s;
    /*动画所花费的时间*/
    /* -webkit-animation-fill-mode: forwards; */
}
</style>



// WEBPACK FOOTER //
// src/feiyi2/views/home/Home.vue